module.exports = __webpack_public_path__ + "img/lampactive.5ce6f20e.svg";